export default __webpack_public_path__ + "static/media/video-2.9104e0ca.mp4";